

export const addPurchaseOrderFunction = async (addPurchase, payload, callback) => {
  await addPurchase(payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.log("err ", err);
    });
};